// source: wisetime/type/seat/seat_policy.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.wisetime.type.seat.SeatAllocationPolicy', null, global);
/**
 * @enum {number}
 */
proto.wisetime.type.seat.SeatAllocationPolicy = {
  SEAT_ALLOCATION_POLICY_UNSPECIFIED: 0,
  SELF_MANAGED: 1,
  SALES_MANAGED: 2
};

goog.object.extend(exports, proto.wisetime.type.seat);
